import { render, staticRenderFns } from "./KTV_params_set.vue?vue&type=template&id=0b277bca&scoped=true"
import script from "./KTV_params_set.vue?vue&type=script&lang=js"
export * from "./KTV_params_set.vue?vue&type=script&lang=js"
import style0 from "./KTV_params_set.vue?vue&type=style&index=0&id=0b277bca&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b277bca",
  null
  
)

export default component.exports